import React from 'react';

import {QuoteContactsItemTypeV1Type} from '../../types/quoteItem';
import {SelectLensesCountConnected} from '../selectLensesCount/selectLensesCount';

import s from './cartItemBoxCount.scss';

export type PropsType = Pick<QuoteContactsItemTypeV1Type, 'id' | 'prescription'> & {
    isDisabled?: boolean;
};

/**
 * Renders boxes count for the CL
 * @param {number} id - item id
 * @param {PrescriptionType} prescription - prescription
 * @param {boolean} isColored - is CL has color
 * @param {boolean} isDisabled - is lenses count select disabled
 * @returns {React.ReactElement} - element
 */
export const CartItemBoxCount: React.FC<PropsType> = ({id, isDisabled = false, prescription}) => {
    const {od, os} = prescription;

    return (
        <div className={s.boxes}>
            <div className={s.box}>
                <span className={s.boxText}>Right eye</span>
                <span className={s.boxCount}>
                    <SelectLensesCountConnected
                        isDisabled={isDisabled || !od.boxes}
                        itemId={id}
                        prescription={prescription}
                        side="od"
                    />
                </span>
            </div>
            <div className={s.divider} />
            <div className={s.box}>
                <span className={s.boxText}>Left eye</span>
                <span className={s.boxCount}>
                    <SelectLensesCountConnected
                        isDisabled={isDisabled || !os.boxes}
                        itemId={id}
                        prescription={prescription}
                        side="os"
                    />
                </span>
            </div>
        </div>
    );
};
